
$(function () {
	var top = $('#top_slide');
	if (top.length) {
		top.slick({
			autoplay: true,
			autoplaySpeed: 3500,
			speed: 1500,
			dots: true,
			arrows: false,
			fade: true,
			draggable: false,
			pauseOnFocus: false,
			pauseOnHover: false,
		});
	}
	var product = $('#top-product');
	if(product.length){
		product.slick({
			variableWidth: true,
			infinite: false,
			autoplay: false,
			autoplaySpeed: 5000,
			dots: true,
			arrows: true,
			touchMove: true,
			touchThreshold: 200,
			prevArrow: $('.slick-pickup-prev'),
			nextArrow: $('.slick-pickup-next')
		});
	}
	var product = $('#top-ranking');
	if(product.length){
		product.slick({
			variableWidth: true,
			infinite: false,
			autoplay: false,
			autoplaySpeed: 5000,
			arrows: true,
			touchMove: true,
			touchThreshold: 200,
			prevArrow: $('.slick-ranking-prev'),
			nextArrow: $('.slick-ranking-next')
		});
	}
	var gift = $('#gift_slide');
	if (gift.length) {
		gift.slick({
			autoplay: true,
			autoplaySpeed: 3500,
			speed: 1500,
			dots: true,
			fade: true,
			focusOnSelect: true,
			// pauseOnFocus:false,
			// pauseOnHover:false,
			arrows: true,
			prevArrow: '<div class="slick-prev gift"></div>',
			nextArrow: '<div class="slick-next gift"></div>',
		});
	}
	var product = $('#product_slide');
	if(product.length){
		product.slick({
			autoplay: true,
			autoplaySpeed: 5000,
			dots: true,
			arrows: true,
			fade: true
		});
	}
	var detail = $('#product_main');
	var detail_sub = $('#product_sub');
	if (detail.length) {
		detail.slick({
			arrows: true,
			autoplay: true,
			fade: true,
			autoplaySpeed: 4000,
			asNavFor: "#product_sub",
			prevArrow: '<div class="slick-prev product"></div>',
			nextArrow: '<div class="slick-next product"></div>',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						asNavFor: false,
						dots: true
					},
				},
			],
		});
		$(window).on('load scroll resize', function () {
			w = $(window).width();
			if (w >= 768) {
				detail_sub.slick({
					arrows: false,
					slidesToShow: 25,
					variableWidth: true,
					focusOnSelect: true,
					draggable: false,
					asNavFor: "#product_main",
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 3,
							},
						},
					],
				});
			}
		});
	}

	var board = $('#board_slide');
	if(board.length){
		board.slick({
			autoplay: false,
			dots: false,
			centerMode: true,
			variableWidth: true,
			prevArrow: $('.slick-board-prev'),
			nextArrow: $('.slick-board-next'),
			responsive: [
				{
					breakpoint: 767,
					settings: {
						centerMode: true,
						// infinite: false,
					}
				}
			]
		});
	}
	var boardStep = $('#board_step');
	if(boardStep.length){
		boardStep.slick({
			autoplay: false,
			autoplaySpeed: 5000,
			dots: false,
			arrows: true,
		});
	}
});